<template>
  <div class="app-main-content">
    <div
      class="main-content"
      type="primary"
    >
      <pod-charge-search-bar
        :filter="filter"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemResetCallBack="toAdvancedQuery"
        @onGridRefresh="gridRefresh"
        @reset="resetGrid"
      >
        <template v-if="activeTabName === 'cpList'" slot="operations">
          <el-button v-show="inputAllowed_PP" no="onEdit" type="primary" :disabled="!this.cpSelectRow" @click="onEdit()">{{ $t('Pricing.Edit') }}</el-button>
          <el-button v-show="deleteAllowed_CP" no="onDeleteCP" type="danger" @click="onDelete_CP()">{{ $t('Pricing.Delete') }}</el-button>
        </template>
        <template v-if="activeTabName !== 'cpList'" slot="operations">
          <el-button v-show="inputAllowed_PP" no="onEdit1" type="primary" :disabled="!this.ppSelectRow" @click="onEdit()">{{ $t('Pricing.Edit') }}</el-button>
          <el-button no="onDeletePP" type="danger" :disabled="!selectedPpRows || selectedPpRows.length === 0" @click="onDelete_PP()">{{ $t('Pricing.Delete') }}</el-button>
          <el-button v-show="approveAllowed_PP" no="onApprovePP" type="primary" :disabled="!selectedPpRows || selectedPpRows.length === 0" @click="onApprove_PP()">{{ $t('Pricing.Approve') }}</el-button>
          <el-button v-show="approveAllowed_PP && filter.level === 0" no="onMarkupApprove" type="primary" :disabled="!selectedPpRows || selectedPpRows.length === 0" @click="onMarkupApprove()">{{ $t('Pricing.markupApprove') }}</el-button>
          <el-button v-show="isHQManager" no="onConfigPriceAir" type="primary" :disabled="false" @click="onConfigPriceAir()">{{ $t('Pricing.Setting') }}</el-button>
          <el-button v-show="inputAllowed_PP" no="onAddPP" type="primary" @click="onAdd_PP()">{{ $t('Pricing.Add') }}</el-button>
          <el-button v-show="inputAllowed_PP" no="onDownloadTemplate" type="primary" @click="onDownloadTemplate()">{{ $t('Pricing.Template') }}</el-button>
          <el-upload
            v-show="inputAllowed_PP"
            no="savePodChargeExcelFile"
            :action="URL.price.savePodChargeExcelFile"
            :headers="{sessionId}"
            :show-file-list="false"
            accept=".xls, .xlsx"
            :on-success="uploadExcelSuccess"
            :data="{currentOfficeId:$store.getters.currentOfficeId}"
            style="display: inline-block; margin-left: 5px"
          >
            <el-button no="import" type="primary">{{ $t('Pricing.Import') }}</el-button>
          </el-upload>
        </template>
      </pod-charge-search-bar>
    </div>
    <div class="tabs-container">
      <el-tabs
        ref="tabs"
        v-model="activeTabName"
        type="card"
        style="width:100%;"
        @tab-click="handleTabClick"
      >
        <el-tab-pane :label="$t('Pricing.CurrentPrice')" name="cpList">
          <pol-charge-data-grid
            :v-if="activeTabName === 'cpList'"
            config-module="224101"
            :show-cost="true"
            :show-create="true"
            :show-modify="true"
            :show-approve="true"
            :show-selection="true"
            :row-data="rowCpData"
            :grid-options="cpGridOptions"
            @selectRowChange="selectRowChange"
          />
          <div ref="txtCpRemark" style="height: 6%; width: 99%" @dblclick="onTxtRemarksDoubleClick()">
            <textarea v-model="txtCpRemarks" no="txtCpRemarks" :disabled="true" style="width: 100%; margin-left: 10px; height: 100%;" :title="$t('Pricing.RemarkAreaToolTip')" />
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('Pricing.PendingPrice')" name="ppList">
          <pol-charge-data-grid
            :v-if="activeTabName === 'ppList'"
            config-module="224102"
            :show-cost="true"
            :show-create="true"
            :show-modify="true"
            :show-selection="true"
            :row-data="rowPpData"
            :grid-options="ppGridOptions"
            @selectRowChange="selectRowChange"
          />
          <div ref="txtPpRemark" style="height: 6%; width: 99%" @dblclick="onTxtRemarksDoubleClick()">
            <textarea v-model="txtPpRemarks" no="txtPpRemarks2" :disabled="true" style="width: 100%; margin-left: 10px; height: 100%;" :title="$t('Pricing.RemarkAreaToolTip')" />
          </div>
        </el-tab-pane>
      </el-tabs>
      <div style="position: absolute; left: 160px;margin: 10px;">
        <span>{{ globalMsg }}</span>
      </div>
    </div>
    <pod-charge-form
      v-if="podChargeFormDialog.visible"
      :visible="podChargeFormDialog.visible"
      :price="podChargeFormDialog.price"
      :is-new="podChargeFormDialog.isNew"
      :is-cp="isActiveCpTab"
      :level="filter.level"
      @close="podChargeFormDialog.visible = false"
      @reload="toQuery"
    />
    <air-markup-popup
      v-if="airMarkupDialog.visible"
      ref="airMarkupPopup"
      :visible="airMarkupDialog.visible"
      :config-util="configUtil"
      :keys="airMarkupDialog.keys"
      :selected-rows="airMarkupDialog.selectedRows"
      @close="airMarkupDialog.visible = false"
      @approveSuccess="onApproveSuccess"
    />
    <air-settings-popup
      v-if="airSettingsPopupDialog.visible"
      ref="airSettingsPopup"
      :visible="airSettingsPopupDialog.visible"
      :config-util="configUtil"
      :is-h-q-manager="isHQManager"
      @close="airSettingsPopupDialog.visible = false"
    />
  </div>
</template>

<script>
import URL from '@/api/urlTranslator'
import DateUtils from '@/utils/dateUtils'
import { getLoading } from '@/utils/utilBaseElement'
import { queryPodCharges, deletePodCharges, approvePodCharges } from '@/api/price/podCharge'
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import StrUtils from '@/utils/StrUtils'
import { deepClone } from '@/utils'
import AirMarkupPopup from '@/views/cargo/v0/Price/PriceAir/components/airMarkupPopup'
import AirSettingsPopup from '@/views/cargo/v0/Price/PriceAir/components/airSettingsPopup'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import { PriceUploadExceptionUtil } from '@/class/cargo/model/utils/PriceUploadExceptionUtil'
import LocalStorageUtils from '@/utils/localStorageUtils'
import PodChargeSearchBar from '@/views/cargo/v0/Price/components/query/podChargeSearchBar'
import { PricingLCLConfigUtil } from '@/class/cargo/model/utils/PricingLCLConfigUtil'
import PolChargeDataGrid from '@/views/cargo/v0/Price/components/grid/polChargeDataGrid'
import PodChargeForm from '@/views/cargo/v0/Price/PODCharge/components/podChargeForm'
export default {
  name: 'PODCharge',
  components: { PodChargeForm, PolChargeDataGrid, PodChargeSearchBar, AirSettingsPopup, AirMarkupPopup },
  data() {
    return {
      URL,
      fullscreenLoading: null,
      configUtil: null,
      airUtil: null,
      isHQManager: false,
      activeTabName: 'cpList',
      approveAllowed_PP: false,
      deleteAllowed_PP: false,
      deleteAllowed_CP: false,
      inputAllowed_PP: false,
      cpSelectRow: null, // 已发布的单击选择行
      ppSelectRow: null, // 待审核的单击选择行
      rowCpData: [],
      rowPpData: [],
      selectedPpRows: null,
      txtCpRemarks: '',
      txtPpRemarks: '',
      remarkCpChange: false,
      remarkPpChange: false,
      cpGridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.onRowDoubleClicked,
        onRowClicked: this.onGridRowClickedEvent,
        onSelectionChanged: event => {
          const rows = event.api.getSelectedRows()
          this.globalMsg = rows.length > 0 ? StrUtils.substitute(this.$t('Pricing.selectedCount'), rows.length) : ''
        }
      },
      ppGridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.onRowDoubleClicked,
        onRowClicked: this.onGridRowClickedEvent,
        onSelectionChanged: event => {
          this.selectedPpRows = event.api.getSelectedRows()
          this.globalMsg = this.selectedPpRows.length > 0 ? StrUtils.substitute(this.$t('Pricing.selectedCount'), this.selectedPpRows.length) : ''
        }
      },
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 10,
        opOffice: 0,
        carrier: 0,
        pol: '',
        pod: '',
        cod: '',
        col: '',
        cmbCreatedBy: 'createdBy',
        level: '',
        currency: 'RMB',
        allIn: false,
        beginDate: DateUtils.formatStandardDate(new Date()),
        endDate: '',
        simPol: 0,
        simPod: 0,
        createdBy: 0
      },
      podChargeFormDialog: {
        visible: false,
        price: {},
        isNew: false
      },
      airMarkupDialog: {
        visible: false,
        selectedRows: [],
        keys: []
      },
      airSettingsPopupDialog: {
        visible: false
      },
      pgsLMap: [],
      globalMsg: '' // 条数和勾选条数显示
    }
  },
  computed: {
    sessionId() {
      return this.$store.getters.token
    },
    isActiveCpTab() {
      return this.activeTabName === 'cpList'
    }
  },
  watch: {
    activeTabName(val) {
      LocalStorageUtils.setConfiguration('PODCharge', val)
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      const activeTab = LocalStorageUtils.getConfiguration('PODCharge')
      this.activeTabName = !StrUtils.isEmpty(activeTab) ? activeTab : 'ppList'
      this.configUtil = await PricingLCLConfigUtil.getInstance()
      this.pgsLMap = this.configUtil.getPOLPrivileges()
      if (this.$store.getters.isAdmin) {
        this.approveAllowed_PP = true
        this.deleteAllowed_PP = true
        this.deleteAllowed_CP = true
        this.inputAllowed_PP = true
      } else {
        this.approveAllowed_PP = this.deleteAllowed_CP = this.configUtil.isApprove
        this.inputAllowed_PP = this.configUtil.isInput
      }
    },
    // tab 页签点击事件
    handleTabClick(tab, event) {
      console.log(tab, event)
      if (tab.name === this.activeTabName && this.$refs[this.activeTabName]) {
        this.$refs[this.activeTabName].fetchOrderRequirement()
      }
    },
    toAdvancedQuery(data) {
      this.proxy = data
      this.toQuery()
    },
    // 查询
    toSimpleQuery(proxy) {
      this.proxy = proxy
      this.toQuery()
    },
    toQuery() {
      this.fullscreenLoading = getLoading()
      this.proxy.state = this.isActiveCpTab ? PriceConstant.PRICE_STATE_EFFECTIVE : PriceConstant.PRICE_STATE_PENDING
      queryPodCharges(this.proxy).then((res) =>
        this.handleQueryData(res)
      ).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    getGridOptionsApi() {
      return this.isActiveCpTab ? this.cpGridOptions.api : this.ppGridOptions.api
    },
    loadingEnd() {
      const api = this.getGridOptionsApi()
      api.clearFocusedCell()
      if (this.isActiveCpTab) {
        this.txtCpRemarks = ''
      } else {
        this.txtPpRemarks = ''
      }
      this.selectRowChange(null)
      this.fullscreenLoading.close()
    },
    handleQueryData(res) {
      const _resMap = res.data
      this.loadingEnd()
      if (!_resMap || _resMap.length === 0) {
        this.$message.warning(this.$t('Pricing.NoRecord'))
        this.setRowData([])
        return
      }
      const count = _resMap.length
      if (PriceUtils.isReturnedPartOfResults(this.proxy.isLimited, count)) {
        this.$message.warning(this.$t('Pricing.MaxQueryCount'))
        _resMap.pop()
      }
      this.setRowData(_resMap)
    },
    setRowData(result) {
      if (this.isActiveCpTab) {
        this.rowCpData = result
      } else {
        this.rowPpData = result
      }
      this.globalMsg = StrUtils.substitute(this.$t('Pricing.QueryRecords'), result.length)
    },
    onRowDoubleClicked(e) {
      const data = e.data
      if (this.isActiveCpTab) {
        this.cpSelectRow = data
      } else {
        this.ppSelectRow = data
      }
      this.onEdit()
    },
    onEdit() {
      const data = this.isActiveCpTab ? this.cpSelectRow : this.ppSelectRow
      if (!data) {
        this.$message.warning(this.$t('Pricing.NoRecordSelect'))
        return
      }
      this.podChargeFormDialog.visible = true
      this.podChargeFormDialog.isNew = false
      if (this.isActiveCpTab) {
        delete data.uuid
      }
      this.podChargeFormDialog.price = deepClone(data)
    },
    selectRowChange(data) {
      if (this.isActiveCpTab) {
        this.cpSelectRow = data
      } else {
        this.ppSelectRow = data
      }
    },
    gridRefresh() {
    },
    resetGrid() {
      this.setRowData([])
      this.selectRowChange(null)
    },
    onTxtRemarksDoubleClick() {
      this.$nextTick(() => {
        const remark = (this.isActiveCpTab) ? 'txtCpRemark' : 'txtPpRemark'
        const remarkChange = (this.isActiveCpTab) ? this.remarkCpChange : this.remarkPpChange
        this.$refs[remark].style.height = !remarkChange ? '30%' : '6%'
        if (this.isActiveCpTab) {
          this.remarkCpChange = !this.remarkCpChange
        } else {
          this.remarkPpChange = !this.remarkPpChange
        }
      })
    },
    onGridRowClickedEvent(e) {
      const data = e.data
      this.selectRowChange(data)
      if (this.isActiveCpTab) {
        this.txtCpRemarks = data.remarks
      } else {
        this.txtPpRemarks = data.remarks
      }
    },
    onAdd_PP() {
      this.podChargeFormDialog.visible = true
      this.podChargeFormDialog.isNew = true
      this.podChargeFormDialog.price = {
        state: PriceConstant.PRICE_STATE_PENDING,
        currency: 'USD',
        payment: 'P',
        generateCharge: true
      }
    },
    onDelete_PP() {
      const selectedRows = this.getSelectedRows()
      if (!selectedRows) return
      for (const item of selectedRows) {
        if (!(this.deleteAllowed_PP || item.createdBy === this.$store.getters.userInfo.userId)) {
          this.$message.warning(this.$t('Pricing.NotAllowedDelete'))
          return null
        }
      }
      const message = selectedRows.length > 1 ? this.$t('Pricing.IsDeleteRecords') : this.$t('Pricing.IsDeleteRecord')
      this.$confirm(message, this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        const uuids = this.getSelectUuids(selectedRows)
        this.toDel(selectedRows, uuids)
      })
    },
    toDel(selectRows, uuids) {
      this.fullscreenLoading = getLoading()
      deletePodCharges(uuids).then(res => {
        this.$message.success(this.$t('Pricing.HasDeleted'))
        this.loadingEnd()
        const api = this.getGridOptionsApi()
        api.updateRowData({ remove: selectRows })
      })
    },
    getSelectUuids(selectedRows) {
      const uuids = []
      selectedRows.forEach(item => {
        uuids.push(item.uuid)
      })
      return uuids
    },
    // 获取待审核的勾选数据
    getSelectedRows() {
      const api = this.getGridOptionsApi()
      const selectedRows = api.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.warning(this.$t('Pricing.NoRecordSelect'))
        return null
      }
      return selectedRows
    },
    onDelete_CP() {
      const selectedRows = this.getSelectedRowsCp()
      if (!selectedRows) {
        return
      }
      if (!this.$store.getters.isAdmin) {
        for (const row of selectedRows) {
          if (!this.pgsLMap.hasOwnProperty(row.pol)) {
            this.$message.warning(StrUtils.substitute(this.$t('Pricing.IsAllowedOperate'), [row.pol, row.pod]))
            return
          }
        }
      }
      this.$confirm(this.$t('Pricing.InvalidSelection'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        const uuids = this.getSelectUuids(selectedRows)
        this.toDel(selectedRows, uuids)
      })
    },
    // 获取已发布的勾选数据
    getSelectedRowsCp() {
      return this.getSelectedRows()
    },
    // 审核
    onApprove_PP() {
      if (this.onApproveChecked()) {
        const selectedRows = this.getSelectedRows()
        const msg = selectedRows.length > 1 ? this.$t('Pricing.IsApproveRecords') : this.$t('Pricing.IsApproveRecord')
        this.$confirm(msg, this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning'
        }).then(() => {
          this.fullscreenLoading = getLoading()
          approvePodCharges(selectedRows).then(res => {
            this.onApproveSuccess(selectedRows)
            this.loadingEnd()
          }).catch(e => {
            this.loadingEnd()
          })
        })
      }
    },
    // 审核前校验
    onApproveChecked() {
      const selectedRows = this.getSelectedRows()
      if (!this.$store.getters.isAdmin) {
        for (const item of selectedRows) {
          if (!this.pgsLMap.hasOwnProperty(item.pol)) {
            this.$message.warning(StrUtils.substitute(this.$t('Pricing.IsAllowedOperate'), item.pol, item.pod))
            return false
          }
        }
      }
      return true
    },
    onConfigPriceAir() {
      this.airSettingsPopupDialog.visible = true
      this.$nextTick(() => {
        this.$refs['airSettingsPopup'].init()
      })
    },
    onApproveSuccess(selectedRows) {
      this.loadingEnd()
      const api = this.getGridOptionsApi()
      api.updateRowData({ remove: selectedRows })
    },
    onDownloadTemplate() {
      ExportUtils.downloadTemplateFile('POD_Charge_sample.xls', 'price')
    },
    uploadExcelSuccess(response, file, fileList) {
      if (response && response.data) {
        this.onImportSucceeded(JSON.parse(response.data))
      } else {
        this.$message.error(this.$t('SeaExport.ImportFailedContactAdministrator'))
      }
    },
    onImportSucceeded(message) {
      if (message.success) {
        const result = message.resultMessage
        const records = result.split(',')
        let msg = ''
        if (records.length > 1) {
          for (const sheet of records) {
            if (StrUtils.isEmpty(sheet)) {
              continue
            }
            const tmp = sheet.split(':')
            msg += StrUtils.substitute(this.$t('Pricing.Records'), tmp) + '\n'
          }
          msg += this.$t('Pricing.LoadSucceed')
          this.$message.success(msg)
        } else {
          if (result === '') {
            this.$message.error(this.$t('Pricing.NoRecordUpload'))
          } else {
            const tmp = result.split(':')
            msg = StrUtils.substitute(this.$t('Pricing.Records'), tmp)
            msg = msg.substr(0, msg.length - 1) + this.$t('Pricing.LoadSucceed')
            this.$message.success(msg)
          }
        }
        return
      }
      // 导入失败
      const failResult = PriceUploadExceptionUtil.handleError(message)
      const msg = {
        dangerouslyUseHTMLString: true,
        message: failResult.replace(/\n\t/g, '<br/>'),
        type: 'error',
        duration: 5000
      }
      this.$message.error(msg)
    }
  }
}
</script>

<style scoped>

</style>
